import type { EmptyObject } from '@freelancer/types';
import type {
  ProfileCategoryApi,
  ProfileCategoryResultApi,
} from 'api-typings/users/users';
import type { ProfileCategory } from './profile-categories.model';
import type { PortfolioViewFilter } from '../../../../app/user-profile/user-profile-editable-ui/user-profile-editable-ui.model';

export const ALL_ITEMS_ID = -1;
export const ALL_ITEMS_POSITION = 0;
export const MAX_CATEGORY_NAME_LENGTH = 19;
export const MAX_PORTFOLIO_CATEGORY_ITEMS = 4;

export interface ProfileCategoriesCollection {
  readonly Name: 'profileCategories';
  readonly DocumentType: ProfileCategory;
  readonly Backend: {
    readonly Fetch: {
      readonly PayloadType: never;
      readonly ReturnType: ProfileCategoryResultApi;
      readonly ErrorType: never;
    };
    readonly Push: {
      readonly ComputedFields: 'id';
      readonly PayloadType: Pick<
        // API processes the id of each portfolio item and not the whole object. Value of last_updated is set by the API.
        ProfileCategoryApi,
        'id' | 'name' | 'user_id' | 'position'
      > & {
        readonly portfolio_items: readonly number[];
        readonly skills?: readonly number[];
      };
      readonly ReturnType: ProfileCategoryApi;
      readonly ErrorType: never;
    };
    readonly Set: never;
    readonly Update: {
      readonly PayloadType: Pick<
        // API processes the id of each portfolio item and not the whole object. Value of last_updated is set by the API.
        ProfileCategoryApi,
        'id' | 'name' | 'user_id' | 'position'
      > & {
        readonly portfolio_items: readonly (number | undefined)[] | undefined;
        readonly skills?: readonly (number | undefined)[];
      };
      readonly ReturnType: ProfileCategoryApi;
      readonly ErrorType: never;
    };
    readonly Delete: {
      readonly PayloadType: EmptyObject;
      readonly ReturnType: never;
      readonly ErrorType: never;
    };
    readonly WebsocketType: never;
  };
  readonly HasTotalCount: false;
}

export interface CategoryPortfolioMapping {
  readonly id: number;
  readonly portfolioItems: readonly number[];
}

export interface PortfolioFilter {
  readonly name: PortfolioViewFilter;
  readonly label: string;
}
